// 导航菜单枚举值（与后端约定）
const navbarMap = {
  0: 'banner',
  1: 'introduction',
  2: 'custom',
  3: 'ecology',
  4: 'broadcast',
  5: 'hardware',
  6: 'cooperation',
  7: 'contact',
  8: 'solution'
};
export { navbarMap };